import { Component, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { SelectionItem } from '../../../core/component/select/select.component';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-select-dialog',
    templateUrl: './select-dialog.component.html',
    styleUrls: ['./select-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectDialogComponent implements OnInit, OnChanges {
  constructor(
    private _fb: FormBuilder,
    private _fc: FormControlExFactory,
    private _modalService: ActionWindowService
  ) {}

  form: FormGroup;

  ngOnInit() {
    this.form = this._fb.group({
      property: this._fc.createMandatory(this.dataContext.fieldName, this.dataContext.defaultValue),
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.dataContext && this.form) {
      this.form.controls['property'].setValue(this.dataContext.defaultValue);
    }
  }

  dataContext: {
    itemsSource: SelectionItem[];
    fieldName: string;
    helpText: string;
    title: string;
    defaultValue: any;
  };

  onSubmit() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this._modalService.complete({ value: this.form.controls['property'].value });
  }

  cancel() {
    this._modalService.close();
  }
}
